import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import {
  getNonGeneralWidgetUrl,
  NON_GENERAL_WIDGET,
  trackWidgetClick,
} from './utils'
import { Anchor } from 'components/Anchor'

import type { IPageCard } from './typings'

const BaseWidget = React.forwardRef<
  HTMLDivElement,
  IPageCard & { className?: string }
>(({ title, thumbnailUrl, excerpt, className, id, trackerWidgetData }, ref) => {
  const url = getNonGeneralWidgetUrl({ type: NON_GENERAL_WIDGET.PageCard, id })
  return (
    <div
      className={clsx(
        'widget-component',
        'widget-component--page-card mb-3 last:mb-0',
        className
      )}
      ref={ref}
    >
      <Anchor href={url}>
        <div
          className={clsx(
            'rounded border border-subdued p-3',
            'flex gap-4 justify-between',
            'bg-white',
            'cursor-pointer'
          )}
          onClick={() =>
            trackWidgetClick({
              ...trackerWidgetData,
              widgetValue: {
                ...trackerWidgetData.widgetValue,
                url,
              },
            })
          }
        >
          <div>
            <Text className="mb-1 line-clamp-2" variant="heading-md">
              {title}
            </Text>
            <Text
              variant="body-sm"
              className="mb-0 mt-1 line-clamp-2"
              color="subdued"
            >
              {excerpt}
            </Text>
          </div>
          <div className="relative flex-grow-0 flex-shrink-0 w-16 h-16 rounded overflow-hidden">
            {!!thumbnailUrl && (
              <img
                className="object-cover object-center w-16 h-16"
                alt="page card thumbnail"
                src={thumbnailUrl}
              />
            )}
            {!thumbnailUrl && (
              <div className="grid place-items-center w-16 h-16 bg-gray-30">
                <Icon>web</Icon>
              </div>
            )}
          </div>
        </div>
      </Anchor>
    </div>
  )
})
BaseWidget.displayName = 'PageCard'

export default BaseWidget
